type SessionExpiredCallback = () => void;

let _onSessionExpired: SessionExpiredCallback | null = null;
let _isActive = false;

export const registerSessionExpiredHandler = (cb: SessionExpiredCallback) => {
  _onSessionExpired = cb;
};

export const unregisterSessionExpiredHandler = () => {
  _onSessionExpired = null;
  _isActive = false;
};

export const notifySessionExpired = () => {
  if (_isActive) return;
  _isActive = true;
  _onSessionExpired?.();
};

export const clearSessionExpiredActive = () => {
  _isActive = false;
};
